<template>
    <div class="Summary">
        <div class="row">
            <div class="col col-md-4">
                <h4>Church Info</h4>
                <p><span class="bold">Name: </span><span>{{ ChurchRecordData.Church.Name }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Program Enrollment</h4>
                <p><span class="bold">Regional Program: </span><span>{{ ChurchRecordData.SubProgramMembership.SubProgram.Name }}</span></p>
                <p><span class="bold">Relationship Started: </span><span>{{ formatDate(ChurchRecordData.SubProgramMembership.StartDate, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">Relationship Ended: </span><span>{{ formatDate(ChurchRecordData.SubProgramMembership.EndDate, 'MM/DD/YY', 'N/A') }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Location</h4>
                <p><span class="bold">Territory: </span><span>{{ ChurchRecordData.Church.Region }}</span></p>
                <p><span class="bold">Physical Address: </span><span>{{ ChurchRecordData.Church.AddressPhysical.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="ChurchRecordData.Church.AddressPhysical" /></p>
                <p><span class="bold">Mailing Address: </span><span>{{ ChurchRecordData.Church.AddressMailing.AddressSingleLine }} </span></p>
            </div>
            <div class="col col-md-4">
                <h4>Owner of Relationship</h4>
                <div v-if="ChurchRecordData.CurrentOwnerOfRelationship != ' '">
                    <p><span>{{ ChurchRecordData.CurrentOwnerOfRelationship }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Main Contact</h4>
                <div v-if="GetCurrentMainContact != null">
                    <p><span class="bold">Name: </span><span>{{ GetCurrentMainContact.Volunteer.Person.FullName }}</span></p>
                    <p><span class="bold">Email: </span><a :href="'mailto:' + GetCurrentMainContact.Volunteer.Person.Email">{{ GetCurrentMainContact.Volunteer.Person.Email }}</a></p>
                    <p><span class="bold">Phone: </span><span>{{ GetCurrentMainContact.Volunteer.Person.PhoneNumbers[0].PhoneNumber.FormattedPhoneNumber }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Ministry Lead</h4>
                <div v-if="GetCurrentMinistryLead != null">
                    <p><span class="bold">Name: </span><span>{{ GetCurrentMinistryLead.Volunteer.Person.FullName }}</span></p>
                    <p><span class="bold">Email: </span><a :href="'mailto:' + GetCurrentMinistryLead.Volunteer.Person.Email">{{ GetCurrentMinistryLead.Volunteer.Person.Email }}</a></p>
                    <p><span class="bold">Phone: </span><span>{{ GetCurrentMinistryLead.Volunteer.Person.PhoneNumbers[0].PhoneNumber.FormattedPhoneNumber }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'ChurchRecordData'
        ],
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {

        },
        computed: {
            GetCurrentMainContact: function() {
                let initList = this.ChurchRecordData.MainContacts.filter(c => c.EndDate == null);
                if (initList.length > 0) {
                    return initList[0];
                } else {
                    return null;
                }
            },
            GetCurrentMinistryLead: function() {
                let initList = this.ChurchRecordData.MinistryLeads.filter(c => c.EndDate == null);
                if (initList.length > 0) {
                    return initList[0];
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
</style>